import { Component, OnInit } from '@angular/core';
import { MessagesService } from '../services/messages.service';
import * as firebase from 'firebase/app';
import 'firebase/auth';
import { Router } from '@angular/router';

@Component({
  selector: 'app-review-messages',
  templateUrl: './review-messages.component.html',
  styleUrls: ['./review-messages.component.scss'],
})
export class ReviewMessagesComponent implements OnInit {
  message: any;
  uid: string;

  constructor(public messageService: MessagesService, private router: Router) {
    firebase.auth().onAuthStateChanged((user) => {
      if (user) {
        this.uid = user.uid;
        
        this.messageService.getMessage().once('value', messageSnapshot => {
          this.message = [];
          messageSnapshot.forEach(snap => {
            if (snap.val().active === 'true') {
              this.message.push({
                title: snap.val().title,
                message: snap.val().message,
                date: snap.val().date,
                messageType: snap.val().message_type,
                user: snap.val().user
              });
            }
            
          });
          console.log('message from component', this.message);
          
        });
      } else {
        this.router.navigateByUrl('login');
      }
    });
  }

  ngOnInit() {}

}
